import { PropsWithChildren } from 'react';

import { VerticalContainer } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { mergeProperties, useNavigation } from '@/caregiverSpace/shared/lib';
import {
    PropertyObjectType,
    PropertyType,
} from '@/caregiverSpace/shared/model';
import { GoToPageButton, PropertiesList } from '@/caregiverSpace/shared/ui';

import { addNationalIdentifierFieldPropertyObject } from '../lib/addNationalIdentifierFieldPropertyObject';
import { addPhoneNumberFieldPropertyObject } from '../lib/addPhoneNumberFieldPropertyObject';

type PatientSectionProps = PropsWithChildren<{
    dateOfBirth: string;
    name: string;
    nationalIdentifier: string;
    patientId: number;
    consultationId?: string;
    mobilePhone?: string;
}>;

export const PatientSection = ({
    dateOfBirth,
    name,
    nationalIdentifier,
    patientId,
    consultationId,
    mobilePhone,
    children,
}: PatientSectionProps) => {
    const { goToPatientPage, goToProfileConsultation } = useNavigation();

    const initialProperties: PropertyObjectType[] = [
        {
            label: R.Name,
            value: (
                <GoToPageButton
                    onClick={() => {
                        if (consultationId) {
                            goToProfileConsultation(patientId, consultationId);
                        } else {
                            goToPatientPage(patientId);
                        }
                    }}
                >
                    {name}
                </GoToPageButton>
            ),
            type: PropertyType.TEXT,
        },
    ];

    const combinedProperties = mergeProperties(
        initialProperties,
        addNationalIdentifierFieldPropertyObject({
            nationalIdentifier,
            birthdate: dateOfBirth,
        }),
        addPhoneNumberFieldPropertyObject({
            phoneNumber: mobilePhone,
        }),
    );
    return (
        <VerticalContainer spacing="sm">
            <PropertiesList properties={combinedProperties} />
            {children}
        </VerticalContainer>
    );
};
